// src/pages/ForSale.jsx
import React from 'react';
import PropertyListingPage from '../PropertyListing/PropertyListing';
import { Helmet } from 'react-helmet';

const ForSale = () => {
  return (
    <>      <Helmet>
            <title>For Sale</title>
            <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
          </Helmet>
  <PropertyListingPage filterType="for-sale" pageTitle="Properties For Sale" />;
  </>
  )
};

export default ForSale;
